<template>
  <section>
    <Goods ref="goods" />
    <Demand ref="demand" />
    <ReceiveOrderLog  ref="receiveOrderLog"/>
  </section>
</template>

<script>
import {
  queryOrderDetail,
  queryOrderVerDetail,
  findOrderRecive, queryGoodDetail,
} from 'api/operate';
import Goods from './goods';
import Demand from './demand';
import ReceiveOrderLog from './receiveOrderLog';
export default {
  components: {
    Goods,
    Demand,
    ReceiveOrderLog,
  },
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
    };
  },
  methods: {
    async getData () {
      this.$nextTick(() => {
        this.$refs.receiveOrderLog.saveSearchBoxData({sourceOfGoodsId: this.$route.query.id});
      });

      const orderId = this.orderId || this.$route.query.orderId;
      const detailRes = await queryOrderDetail({
        orderId,
        // 生产旧版 OrderBO 仅接受 2/3；详情沿用原有 3，仅通过 skipReportCost 跳过慢成本报表。
        orderDetailsType: 3,
        skipReportCost: 1,
      });
      if (detailRes.failed) {
        const confirmRes = await this.$confirm('很抱歉，正在维修保养中，请稍后再试！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning',
        }).catch(() => { // 取消删除
        });
        if (confirmRes) {
          this.close();
        }
      }

      let detailVerRes = {};
      if (detailRes.orderInfo && detailRes.orderInfo.orderUpdateState === 2) {
        if (this.$route.query.type === 'approve') {
          detailVerRes = await queryOrderVerDetail({
            orderId,
          });
        }
      }
      const resReceipts = await findOrderRecive({
        orderId,
      });

      if (!detailRes.failed) {
        if (resReceipts.items && resReceipts.items.length) {
          detailRes.receipts = resReceipts.items;
        }
        const goodsDetailRes = await queryGoodDetail({ // 货源详情
          id: this.id || this.$route.query.id,
        });
        if (!goodsDetailRes.failed) {
          // 合并 详情数据 和 审核数据，方便对比
          const combindDetailRes = Object.assign({isVerity: this.$route.query.isVerity}, detailVerRes, detailRes, goodsDetailRes);
          this.$nextTick(() => {
            this.$refs.goods.getData(combindDetailRes);
          });
          this.$nextTick(() => {
            this.$refs.demand.getData(goodsDetailRes);
          });
        }
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>


<style lang="scss">
.order-detail-content-box {
  padding: 5px 0;
  .order-detail-content-item {
    line-height: 30px;
    .order-detail-content-item-label {
      display: inline-block;
      width: 90px;
    }
  }
}
</style>
